module.exports = __webpack_public_path__ + "img/Kpica.e8d1a4cf.png";